import { graphql } from "react-apollo"

import withPageTitle from "../../routes/containers/withPageTitle"
import DashboardWrapper from "../components/DashboardWrapper"
import dashboard from "../queries/dashboard"
import { Dashboard } from "../queries/types/Dashboard"

export default withPageTitle("Dashboard")(
  graphql<unknown, Dashboard, unknown, unknown>(dashboard, {
    // errorPolicy "all" keeps whatever fields did resolve. Without it, a single
    // failing field (e.g. an unconfigured license cycle) throws away the entire
    // response and the dashboard renders as if the user owned no courses.
    options: { fetchPolicy: "cache-and-network", errorPolicy: "all" },
  })(DashboardWrapper)
)
